import Api from "..";

const login = async (usuario, senha) => {
    try {
        const response = await Api.post("/login", { usuario, senha });
        return response.data;
    } catch (error) {
        console.error('Erro no login:', error);
        
        if (error.response) {
            // Server responded with error status
            const message = error.response.data?.erro || error.response.data?.message || 'Erro no servidor';
            throw new Error(`Erro ao fazer login: ${message}`);
        } else if (error.request) {
            // Request was made but no response received
            throw new Error('Erro ao fazer login: Não foi possível conectar ao servidor');
        } else {
            // Something else happened
            throw new Error(`Erro ao fazer login: ${error.message}`);
        }
    }
};

export default {
    login
};
